import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor{
  authToken: string;

constructor( private auth: AuthService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
    this.authToken = this.auth.token;
    if(!this.authToken){
      console.log('Not Authenticated');
      return next.handle(req);}
    const reqWithToken = req.clone({
      headers: req.headers.set('Authorization' , `Bearer ${this.authToken}`)
    });

    return next.handle(reqWithToken);

  }
}
